const weatherChoicesBg = [
  {
    label:
      "Стабилно, меко време със зелени пейзажи и естествени кафяви тонове.",
    value:
      'Steady, mild weather with green landscapes and earthy brown tones.{"Green":"3","Brown":"2"}',
  },
  {
    label: "Облачни дни с интроспективни сиви и мистериозни черни облаци.",
    value:
      'Cloudy days with introspective gray and mysterious black clouds.{"Gray":"3","Black":"2"}',
  },
  {
    label: "Спокойни, ясни дни със сини небеса и магически виолетови вечери.",
    value:
      'Calm, clear days with blue skies and magical violet evenings.{"Blue":"3","Violet":"2"}',
  },
  {
    label:
      "Горещи, слънчеви дни с експлозии от жълто и енергични бури.",
    value:
      'Hot, sunny days with bursts of yellow and energetic storms.{"Red":"3","Yellow":"2"}',
  },
];

export default weatherChoicesBg;
